import {Fragment, h} from 'preact';
import s from "./sidebarMenu.module.css";
import Content from "./Content";
import {useSidebarMenu} from "./useSidebarMenu";
import {useBehavioralContext} from "../../contexts";

const SidebarMenu = () => {
    // Retrieves the menu action stuff
    const {
        isMenuOpen,
        handleMenu
    } = useBehavioralContext();

    // Component logic data
    const componentProps = useSidebarMenu({
        isMenuOpen
    });

    const {} = componentProps;

    return (
        <Fragment>
            <div className={s.root + (isMenuOpen ? ` ${s.isOpen}` : "")} data-testid="sidebar-menu-container">
                <div className={"w-full h-screen flex flex-col items-start"}>
                    {/* Cart content section. All data that will be listed on it should be passed to it as a property */}
                    <Content
                        handleIntrinsicMenu={handleMenu}
                    />
                </div>
            </div>

            {/* Backdrop element */}
            <div
                className={s.backdrop + (isMenuOpen ? ` ${s.openBackdrop}` : "")}
                onClick={() => handleMenu()}
                data-testid="sidebar-menu-backdrop"
            />
        </Fragment>
    )
}

export default SidebarMenu;
